import React from 'react';

class Checkbox extends React.Component {

    constructor() {
        super();
        this.state = {
            isChecked: false
        };
        this.toggleChange = this.toggleChange.bind(this);
    }
    componentDidMount(){
        if(this.props.checked){
            this.setState({
                isChecked: true
            });
        }
    }
    componentWillReceiveProps(next){
        if(this.props.checked !== next.checked){
            this.setState({
                isChecked: !this.props.checked
            });
        }
    }
    toggleChange (e) {
        let val = e.target.value;

        this.setState({
            isChecked: !this.state.isChecked
        }, () => {
            this.props.handleChange(val, this.state.isChecked);
        });

    }
    render(){
        return (
            <label className={this.state.isChecked? 'checkbox checked': 'checkbox'}>
                <div className="checked-box">
                    <svg viewBox="0 0 37.08 41.77">
                        <polyline points="0.4 25.89 11.65 40.89 36.65 0.26" fill="none" stroke="#000"/>
                    </svg>
                </div>
                <input
                    type="checkbox"
                    checked={this.state.isChecked}
                    onChange={this.toggleChange}
                    name={this.props.name}
                    value={this.props.value}
                />
                <span dangerouslySetInnerHTML={{__html:this.props.label}}></span>
            </label>
        );
    }
}

export default Checkbox;


/** WEBPACK FOOTER **
 ** ./src/js/components/parts/checkbox.js
 **/